/* eslint-disable */
export const magniferIcon = {
  data: `<svg viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.7799 20.5403C15.6969 20.5403 19.6829 16.5543 19.6829 11.6373C19.6829 6.72037 15.6969 2.73438 10.7799 2.73438C5.86295 2.73438 1.87695 6.72037 1.87695 11.6373C1.87695 16.5543 5.86295 20.5403 10.7799 20.5403Z" stroke="currentColor" stroke-width="1.40573"/><path d="M17.3403 18.1953L20.6204 21.4754" stroke="currentColor" stroke-width="1.40573" stroke-linecap="round"/></svg>`,
  name: 'magnifer' as const,
};
